import { Injectable, ElementRef } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged, map, Observable, shareReplay, tap } from 'rxjs';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Platform } from '@ionic/angular';

interface ResizeElement{
    elementRef?: ElementRef,
    isMobile?: BehaviorSubject<boolean>,
    maxWidth: number,
    width?: number
}


export enum ScreenSize {
  MobilePortrait = 'MobilePortrait',
  TabletPortrait = 'TabletPortrait',
  TabletLandscape = 'TabletLandscape',
  Web = 'Web'
}

@Injectable({
  providedIn: 'root'
})
export class ResizeManagerService {

  public screenSize: ScreenSize = ScreenSize.Web 

  private readonly screenSizeObserver: Observable<BreakpointState> = this.breakpointObserver
    .observe([ Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape, Breakpoints.TabletPortrait, Breakpoints.TabletLandscape, Breakpoints.WebPortrait, Breakpoints.WebLandscape ])
    .pipe( distinctUntilChanged() ) 

  public screenSizeChanged: BehaviorSubject<ScreenSize> = new BehaviorSubject<ScreenSize>(this.screenSize)

  public get isPortrait(): boolean {
    return this.screenSize == ScreenSize.MobilePortrait || this.screenSize == ScreenSize.TabletPortrait
  }

  public get isWeb(): boolean {
    return this.screenSize == ScreenSize.Web
  }

  public get isMacApp(){
    return this.platform.is('electron') && (navigator.userAgent.includes('Macintosh') || navigator.userAgent.includes('Mac OS X'));
  }

  constructor(
    private breakpointObserver: BreakpointObserver,
    private platform: Platform
  ) { 
    this.screenSizeObserver.subscribe((state: BreakpointState) => {
      if(this.breakpointObserver.isMatched(Breakpoints.TabletLandscape) || this.breakpointObserver.isMatched(Breakpoints.WebPortrait) || this.breakpointObserver.isMatched(Breakpoints.HandsetLandscape)) this.screenSize = ScreenSize.TabletLandscape
      else if(this.breakpointObserver.isMatched(Breakpoints.TabletPortrait)) this.screenSize = ScreenSize.TabletPortrait
      else if(this.breakpointObserver.isMatched(Breakpoints.HandsetPortrait)) this.screenSize = ScreenSize.MobilePortrait
      else if(this.platform.is("electron")) this.screenSize = ScreenSize.Web
      else if(this.platform.is("tablet")) this.screenSize = ScreenSize.TabletLandscape
      else this.screenSize = ScreenSize.Web
      this.screenSizeChanged.next(this.screenSize)
    })
  }
}
